module.exports = __webpack_public_path__ + "314daed04b56334915b47ba97f4e4567.svg";